import { NgModule } from '@angular/core';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CarouselModule } from 'primeng/carousel';
import { PanelMenuModule } from 'primeng/panelmenu';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {PanelModule} from 'primeng/panel';



@NgModule({
  declarations: [

  ],
  imports: [

  ],
  exports: [
    ScrollPanelModule,
    CarouselModule,
    PanelMenuModule,
    ConfirmDialogModule,
    BrowserAnimationsModule,
    PanelModule
  ],
  providers: [ConfirmationService]
})
export class PrimeNgModule { }
